import { EXTERNAL_PATH } from 'router/const/externalPath.const';
import { Roles } from 'modules/core/enums';

export const LOGO_DATA_MAP = new Map<Roles, string>([
  [Roles.GLOBALADMIN, EXTERNAL_PATH.GLOBAL_ADMIN_PANEL],
  [Roles.ADMIN, EXTERNAL_PATH.ADMIN_PANEL],
]);
